<template>

<div class="family" v-on:click="$emit('click')">

    <div class="family-colour" :style="{backgroundColor: (family.style) ? family.colour : false, color: (family.style) ? family.fore : false}" />

    <div class="family-name">

        {{ family.name }} 
    
        <i class="fa fa-caret-right" />

    </div>

</div>

</template>

<script>

export default {

	props: ['family']

}

</script>

<style scoped>

.family {
	font-size: 14px;
    color: #fff;
	height: 24px;
	line-height: 24px;
    border-radius: 4px;
	user-select: none;
    padding: 0px 10px;
    cursor: pointer;
    font-weight: 400;
    display: grid;
    grid-template-columns: 16px auto;
	cursor: pointer;
    align-items: center;
    flex-direction: row;
    grid-gap: 10px;
}

.family-colour {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background-color: #133445;
    color: #fff;
    border: 1px solid #fff;
}

.family .fa {
	position: absolute;
	right: 5px;
	top: 0px;
	line-height: 24px;
	color: #fff;
}

.family:hover {
	background-color: rgba(0, 0, 0, 0.15);
}

</style>
